// hooks/useFetchLoginHistories.js
import { useState, useCallback } from "react";
import API from "../../../services/api";

export const useFetchLoginHistories = (
  isLoading,
  setIsLoading,
  totalPages,
  setTotalPages
) => {
  const [loginHistories, setLoginHistories] = useState([]);
  const [totalData, setTotalData] = useState(0);

  const fetch = useCallback(
    async ({
      currentPage = 1,
      currentPerPage = 20,
      searchName = "",
      startDate = "",
      endDate = "",
      selectedRole = "",
    }) => {
      setIsLoading(true);
      try {
        await new Promise((resolve) => setTimeout(resolve, 300));

        const params = new URLSearchParams();
        params.append("page", currentPage);
        params.append("per_page", currentPerPage);

        if (searchName.trim()) {
          params.append("name", searchName.trim());
        }
        if (startDate) {
          params.append("start_date", startDate);
        }
        if (endDate) {
          params.append("end_date", endDate);
        }
        if (selectedRole) {
          params.append("role", selectedRole);
        }

        const res = await API.get(`/login-histories?${params.toString()}`);

        const dataSorted = [...res.data.data].sort(
          (a, b) => new Date(b.logged_in_at) - new Date(a.logged_in_at)
        );

        setLoginHistories(dataSorted);
        setTotalData(res.data.total);
        setTotalPages(res.data.last_page);
      } catch (err) {
        console.error("Error table:", err);
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { loginHistories, totalData, totalPages, fetch };
};
